import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const resizableDefaultVariants = {
  "direction": "horizontal"
}
const resizableCompoundVariants = []

const resizableSlotNames = [
  [
    "panelGroup",
    "resizable__panelGroup"
  ],
  [
    "panel",
    "resizable__panel"
  ],
  [
    "handle",
    "resizable__handle"
  ],
  [
    "handleIcon",
    "resizable__handleIcon"
  ]
]
const resizableSlotFns = /* @__PURE__ */ resizableSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, resizableDefaultVariants, getSlotCompoundVariant(resizableCompoundVariants, slotName))])

const resizableFn = memo((props = {}) => {
  return Object.fromEntries(resizableSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const resizableVariantKeys = [
  "direction"
]
const getVariantProps = (variants) => ({ ...resizableDefaultVariants, ...compact(variants) })

export const resizable = /* @__PURE__ */ Object.assign(resizableFn, {
  __recipe__: false,
  __name__: 'resizable',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: resizableVariantKeys,
  variantMap: {
  "direction": [
    "horizontal",
    "vertical"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, resizableVariantKeys)
  },
  getVariantProps
})